export async function extractEntitiesFromText(text: string): Promise<string[]> {
  const matches = text.match(/\b[A-Z][A-Za-z0-9+.-]{2,}\b/g) ?? [];
  const unique = Array.from(new Set(matches));
  return unique.slice(0, 12);
}
